import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiMail, FiPhone, FiFileText } = FiIcons;

const PrivacyPolicy = () => {
  const lastUpdated = "29/04/2025";
  
  return (
    <div className="pt-16 min-h-screen bg-white">
      <section className="bg-brand-blue py-20 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-black mb-6 uppercase tracking-tight"
          >
            Privacy Policy
          </motion.h1>
          <p className="text-xl text-brand-silver max-w-3xl mx-auto font-light">
            Informazioni sulla protezione dei dati per Castello SRL.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-brand-silver/20">
            <div className="mb-8 text-sm text-brand-subtle">
              Ultimo aggiornamento: {lastUpdated}
            </div>
            
            <div className="prose prose-blue max-w-none text-brand-blue/80">
              <h2 className="text-2xl font-bold text-brand-blue mt-12 mb-6">1. Titolare del Trattamento</h2>
              <p className="mb-4">
                Il titolare del trattamento dei dati è <strong>Castello SRL</strong> con sede legale in Via Ravizza 14, 20149 Milano, Italia. 
                Partita IVA: 10257200963.
              </p>
              <p className="mb-4">
                Per qualsiasi domanda riguardante la presente informativa o per l'esercizio dei tuoi diritti GDPR, puoi contattarci ai seguenti recapiti:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li><strong>Email:</strong> info@castellomanagement.it</li>
                <li><strong>Telefono:</strong> +39 335 834 4557</li>
                <li><strong>Indirizzo Postale:</strong> Via Ravizza 14, 20149 Milano (MI)</li>
              </ul>

              <h2 className="text-2xl font-bold text-brand-blue mt-12 mb-6">2. Tipologia di Dati Raccolti</h2>
              <p className="mb-4">
                Attraverso il nostro sito web raccogliamo dati necessari per la fornitura dei nostri servizi di Property Management e per rispondere alle tue richieste di preventivo (Simulatore ROI):
              </p>
              <ul className="list-disc pl-6 mb-6">
                <li>Dati identificativi (Nome, Cognome)</li>
                <li>Dati di contatto (Email, Telefono)</li>
                <li>Dati relativi all'immobile (Indirizzo, superficie, dotazioni)</li>
                <li>Dati di navigazione (tramite Cookie tecnici e analitici)</li>
              </ul>

              <h2 className="text-2xl font-bold text-brand-blue mt-12 mb-6">3. Finalità del Trattamento</h2>
              <p className="mb-4">
                I dati vengono trattati esclusivamente per:
              </p>
              <ol className="list-decimal pl-6 mb-6 space-y-2">
                <li>Fornire la stima dei ricavi tramite il simulatore</li>
                <li>Contattarti per una consulenza personalizzata richiesta tramite i moduli</li>
                <li>Adempiere ad obblighi legali e fiscali</li>
                <li>Migliorare l'esperienza d'uso del sito web</li>
              </ol>

              <div className="bg-brand-blue/5 p-6 rounded-2xl border-l-4 border-brand-gold my-8">
                <p className="text-sm italic">
                  I tuoi dati non saranno mai venduti a terzi. Il trattamento avviene nel pieno rispetto del Regolamento UE 2016/679 (GDPR).
                </p>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-brand-silver/20">
              <Link to="/" className="inline-flex items-center text-brand-gold hover:text-brand-blue font-bold uppercase tracking-widest text-sm">
                <SafeIcon icon={FiFileText} className="h-4 w-4 mr-2" />
                Torna alla Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;